// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import Button from "elevate-ui/Button";

type $Props = {
  hideMortgageCalc: boolean,
  classes: Object,
};

const MortgageCalculator = ({ classes }) => (
  <div
    className={classes.box}
    style={{
      background: `linear-gradient(rgba(20, 20, 20,0.5), rgba(20, 20, 20, 0.5)), url(https://elevate-images.imgix.net/shared/mortgage-resource.jpg) center/cover no-repeat`,
    }}
  >
    <span>Mortgage</span>
    <span className={classes.largeText}>Calculator</span>
    <Button href="/mortgage-calculator" element="a" color="#ffffff">
      More Info
    </Button>
  </div>
);

const renderMortgageCalculator = (
  hideMortgageCalc: boolean,
  classes: Object
) => {
  if (!hideMortgageCalc) {
    return <MortgageCalculator classes={classes} />;
  } else return;
};

const PhotoBox = ({ hideMortgageCalc, classes }: $Props) => {
  return (
    <div className={classes.root}>
      {renderMortgageCalculator(hideMortgageCalc, classes)}
      <div
        className={classes.box}
        style={{
          background: `linear-gradient(rgba(20, 20, 20,0.5), rgba(20, 20, 20, 0.5)), url(https://elevate-images.imgix.net/shared/buying-selling-resource.jpg) center/cover no-repeat`,
        }}
      >
        <span>Tips for</span>
        <span className={classes.largeText}>buying and selling</span>
        <Button href="/tips/buying" element="a" color="#ffffff">
          More Info
        </Button>
      </div>
      <div
        className={classes.box}
        style={{
          background: `linear-gradient(rgba(20, 20, 20,0.5), rgba(20, 20, 20, 0.5)), url(https://elevate-images.imgix.net/shared/market-analysis-resource.jpg) center/cover no-repeat`,
        }}
      >
        <span>Free Market</span>
        <span className={classes.largeText}>Analysis</span>
        <Button href="/sell" element="a" color="#ffffff">
          More Info
        </Button>
      </div>
    </div>
  );
};

const styles = (theme) => ({
  root: {
    display: "flex",
    position: "relative",
    flexFlow: "row wrap",
    justifyContent: "space-around",
    alignItems: "center",
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "48px 0",
  },
  box: {
    flex: "0 1 100%",
    display: "flex",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "8px 16px",
    textAlign: "center",
    minHeight: "200px",
    [theme.breakpoints(900)]: {
      flex: "0 1 30%",
    },
    "& span": {
      display: "block",
      fontSize: "1.6875rem",
      color: theme.colors.white,
      textTransform: "uppercase",
    },
  },
  largeText: {
    display: "block",
    marginBottom: theme.spacing.unit * 1.5,
    fontSize: "2.25rem !important",
  },
});

export default withStyles(styles)(PhotoBox);
